// extracted by mini-css-extract-plugin
export default {"component":"input-editor-component_component_z7taW","component__title":"input-editor-component_component__title_oi_xD","error":"input-editor-component_error_utI3W"};